import React, { useEffect, useState } from "react";

export default function DiceRollOverlay({ result, onDone }) {
  const [phase, setPhase] = useState("rolling"); // rolling | revealed
  useEffect(() => {
    const t1 = setTimeout(() => setPhase("revealed"), 1200);
    const t2 = setTimeout(() => onDone(), 3200);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  const outcome = result?.outcome || "";
  const isSuccess = outcome.toLowerCase().includes("success");
  const isCrit = outcome.toLowerCase().includes("crit");

  return (
    <div className="fixed inset-0 z-40 bg-black/85 flex items-center justify-center backdrop-blur-sm" data-testid="dice-overlay" onClick={onDone}>
      <div className="text-center space-y-6 px-6">
        <div className="font-mono text-[0.7rem] uppercase tracking-[0.4em] gold">
          {result.stat} Check · DC {result.dc}
        </div>
        <div className={`inline-block ${phase === "rolling" ? "dice-spin" : ""}`}>
          <div className="w-32 h-32 sm:w-40 sm:h-40 rounded-lg border-2 border-amber-500 bg-stone-950 flex items-center justify-center font-serif-display text-6xl sm:text-7xl gold shadow-[0_0_40px_-4px_rgba(212,175,55,0.6)]">
            {phase === "rolling" ? "?" : result.roll}
          </div>
        </div>
        {phase === "revealed" && (
          <div className={`fade-up font-serif-display text-2xl sm:text-3xl tracking-widest uppercase ${isSuccess ? "text-emerald-400" : "text-red-400"} ${isCrit ? "animate-pulse" : ""}`}>
            {outcome}
          </div>
        )}
        <div className="font-mono text-[0.65rem] uppercase tracking-widest text-stone-600">Tap to dismiss</div>
      </div>
    </div>
  );
}
